import { EventEmitter } from 'events';
import io from 'socket.io-client';
import { ServerSideEventType, ServerSideEvent, } from './type';

export class WebsocketClientClass extends EventEmitter {

    public socket: SocketIOClient.Socket = {} as SocketIOClient.Socket;

    /**
     * 连接服务器
     * @param websocketServerUrl 远程Websocket服务器连接地址
     */
    public connect(websocketServerUrl: string) {
        // $ init
        this.socket = io(websocketServerUrl, {
            reconnectionAttempts: 10,
        });
        // $ init events
        // 默认事件
        this.socket.on('connect', () => {
            this.emit('CONNECT')
        });
        this.socket.on('connect_error', () => {
        });
        this.socket.on('disconnect', () => {
        });
        // 重连成功之后才触发的
        this.socket.on('reconnect', () => {
        });
        // 重连失败
        this.socket.on('reconnect_error', () => {
        });
        this.socket.on('reconnect_failed', () => {
            this.emit('DIS_CONNECT')
        });

        // $ connect
        this.socket.connect();
    }

    /**
     * 断开服务器
     */
    public disconnect() {
        if (this.socket && this.socket.close) {
            this.socket.close();
        }
        if (this.socket && this.socket.disconnect) {
            this.socket.disconnect();
        }
    }

    /**
     * 往服务器发送消息
     */
    public emitToServer(
        event: ServerSideEventType,
        params: ServerSideEvent,
        callback: () => void = () => { }
    ) {
        this.socket.emit(
            event,
            params,
            callback
        );
    }


    /**
     * 往服务器发送消息（同步版本）
     */
    public async emitToServerAsync(
        event: ServerSideEventType,
        params: ServerSideEvent
    ) {
        return await new Promise((resolve: any, reject: any) => {
            try {
                this.socket.emit(
                    event,
                    params,
                    () => { resolve() }
                );
            } catch (error) {
                reject(error);
            }
        });
    }


}

export const DefaultWebsocketClient = new WebsocketClientClass();